import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout.jsx";
import PrivateRoute from "./components/PrivateRoute.jsx";
import Login from "./pages/Login.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import EvaluationForm from "./pages/EvaluationForm.jsx";
import GrantDetail from "./pages/GrantDetail.jsx";
import AdminUsers from "./pages/AdminUsers.jsx";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/grants/:id"
        element={
          <PrivateRoute>
            <Layout>
              <GrantDetail />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/evaluate"
        element={
          <PrivateRoute>
            <Layout>
              <EvaluationForm />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <PrivateRoute adminOnly>
            <Layout>
              <AdminUsers />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
